import {DIRECTIONS} from "constants/AppConstants.js";

export default class EnsureUtil {
  static ensureNumber(value: any): number {
    if (isNaN(value)) {
      return 0;
    }

    return value;
  }

  static ensurePositiveNumber(value: any): number {
    if (isNaN(value)) {
      return 0;
    }

    if (value < 0) {
      return 0;
    }

    return value;
  }

  static ensureTwoDigitNumber(value: any): string | number {
    // null and blank strings coerce to 0 for isNaN but parseInt to NaN, so exclude them first.
    if (value === null || `${value}`.trim() === "" || isNaN(value)) {
      return "00";
    }

    value = parseInt(value);

    return value < 10 ? `0${value}` : value;
  }

  static ensureDirectionInShortForm(direction: string): string {
    let output: string;

    switch (direction) {
      case DIRECTIONS.North:
        output = DIRECTIONS.N;
        break;
      case DIRECTIONS.NorthEast:
        output = DIRECTIONS.NE;
        break;
      case DIRECTIONS.East:
        output = DIRECTIONS.E;
        break;
      case DIRECTIONS.SouthEast:
        output = DIRECTIONS.SE;
        break;
      case DIRECTIONS.South:
        output = DIRECTIONS.S;
        break;
      case DIRECTIONS.SouthWest:
        output = DIRECTIONS.SW;
        break;
      case DIRECTIONS.West:
        output = DIRECTIONS.W;
        break;
      case DIRECTIONS.NorthWest:
        output = DIRECTIONS.NW;
        break;
      default:
        output = direction;
    }

    return output;
  }
}
